/**
 * Dimensions of components used in JV and QV
 */
export const UNITE_EVENT_PANE_WIDTH = 480;
export const UNITE_RADIOS_PANE_WIDTH = 336;
export const LOCATION_LIST_CONTAINER_WIDTH = 360;
export const DATA_TABS_HEIGHT = 70;
